export default class LiveSwitchAudioAnalyser{
    constructor(options){
        this.webRTCHandler = options.webRTCHandler;

        this.thresholdLevel = (options && options.hasOwnProperty('thresholdLevel')) ? options.thresholdLevel : 10;
        this.thresholdTime = (options && options.hasOwnProperty('thresholdTime')) ? options.thresholdTime : 200;

        this.thresholdTimeInSamples = Math.round(this.thresholdTime / 20);

        this.lastAudioReceived = {}
        this.currentHighestUser = '';
        this.comparesWon = 0;
        this.currentSpeaker = '';
    }

    userJoined(userId){
        this.lastAudioReceived[userId] = 0;
    }

    userLeft(userId){
        delete this.lastAudioReceived[userId];
    }

    audioReceived(userAudio){
        if(!this.lastAudioReceived.hasOwnProperty(userAudio.userId) || Object.keys(this.lastAudioReceived).length < 2){
            return;
        }

        const audioLevelPercent = Math.round(userAudio.audioLevel * 100);
        this.lastAudioReceived[userAudio.userId] = audioLevelPercent;

        if(audioLevelPercent >= this.thresholdLevel){
            let higherValueFound = false;
            for (let userId in this.lastAudioReceived) {

                if(userAudio.userId !== userId && audioLevelPercent < this.lastAudioReceived[userId]){
                    higherValueFound = true;
                    break;
                }
            }

            if(!higherValueFound){
                // You are the highest
                if(this.currentHighestUser === userAudio.userId){
                    this.comparesWon++;

                    if(this.comparesWon >= this.thresholdTimeInSamples){
                        if(this.currentSpeaker !== userAudio.userId){
                            this.currentSpeaker = userAudio.userId
                            this.webRTCHandler.onSpeakerDetected(this.currentSpeaker);
                        }
                    }
                }
                else{
                    this.currentHighestUser = userAudio.userId;
                    this.comparesWon = 1;
                }
            }
        }
    }
}